/**
 * api 接口
 */

const Lapi='/fapi'//http://test.api.official.unionfit.cn
const Wapi='/wxampapi'
const ampapi='/xcxampapi'
//
const userApi = {


  // http://test.wxamp.unionfit.cn/Wxsdk/getJsAuth
  getykfxqm: Wapi+'/Wxsdk/getJsAuth',  //首页


	getHomeInfo: Lapi+'/api/index/getHomePage',  //首页
  getJsAuth:Lapi+'/api/common/getJsAuth',//获取地理位置 相关配置
  getUserInfo:Lapi+'/api/login/updateUserInfo',//'/api/login/saveUserInfo',//获取用户详情
  getSmsCaptcha:Lapi+'/api/login/sendSmsCode',//'/api/login/getSmsCaptcha',//获取验证码
  getLogin:Lapi+'/api/login/loginAction',//'/api/login/doLogin',//登录
  getInfo:Lapi+'/api/user/getInfo',//获取用户信息
  getRealNameSystem:Lapi+'/api/user/realNameSystem',//实名
  getActivationByCdk:Lapi+'/api/user_cards/activationByCdk',//cdk激活
  getMakeCdkGiftLog:Lapi+'/api/user_cards/makeCdkGiftLog',//礼品记录
  getActivationByUser:Lapi+'/api/user_cards/activationByUser',//企业激活
  getIsRetailUser:Lapi+'/api/user/getIsRetailUser',//判断是否为分销人员
  getUserCards:Lapi+'/api/user_cards/userCards',//获取用户所有卡详情
  getGiftLogs:Lapi+'/api/user_cards/getGiftLogs',//获取有礼品记录
  getCardDetail:Lapi+'/api/user_cards/detail',//获取卡详情
  getOrderList:Lapi+'/api/order/getOrderList',//获取订单列表[即将废弃]
  getOrderDetail:Lapi+'/api/order/getOrderDetail',//获取订单详情[即将废弃]
  getRefund:Lapi+'/api/order/refund',//取消订单[即将废弃]
  getCouponList:Lapi+'/api/user/couponList',//获取优惠券列表
  getProductsCards:Lapi+'/api/cards/productsCards',//获取公司在售产品卡
  getCity:Lapi+'/api/index/getCity',//获取城市列表
  getStadiums:Lapi+'/api/index/getStadiums',// 获取酒店列表[即将废弃]
  getSingleStadium:Lapi+'/api/index/getSingleStadium',//获取单个酒店数据[即将废弃]
  realNameSystem:Lapi+'/api/user/realNameSystem',//实名信息
  getStadiumOrderDetail:Lapi+'/api/stadium/getOrderDetail',//获取可预约数据
  orderFit:Lapi+'/api/stadium/orderFit',//健身下单[即将废弃]
  doYogaOrder:Lapi+'/api/stadium/doYogaOrder',//瑜伽下单
  buyCard:Lapi+'/api/cards/buy',//购卡[即将废弃]
  checkCouponReceive:Lapi+'/api/user/checkCouponReceive',//检查是否包含优惠券
  detailByOrderNo:Lapi+'/api/user_cards/detailByOrderNo',//获取订单详情
  getCardDetailAccordCardId:Lapi+'/api/user_cards/detail',//根据user_cards_id获取卡详情
  getBrandList:Lapi+'/api/brand/getDetail',//获取酒店品牌列表
  noCardMakeBookOrder:Lapi+'/api/stadium/makeBookOrder',//无卡下单
  getSeckillStadiums:Lapi+'/api/special/seckillStadiums',//秒杀接口
  getBanners:Lapi+'/api/home/banners',//获取首页banner
  getBrands:Lapi+'/api/home/brands',//获取品牌
  getIndexStadiums:Lapi+'/api/home/indexStadiums',//获取品牌
  getYogaCourses:Lapi+'/api/home/yogaCourses',//获取瑜伽课程
  getFityogastocks:Lapi+'/api/home/fityogastocks',//健身瑜伽课程
  getBlacklist:Lapi+'/api/user/isInBlacklist',//判断用户是否在黑名单中
  getDateStadiums:Lapi+'/api/home/dateStadiums',//根据日期获取当前可预订的日期
  cancelPay:Lapi+'/api/stadium/cancelPay',//取消支付。当订单支付失败或取消支付需要执行此步骤用以释放库存[即将废弃]
  couponDetailByShareCode:Lapi+'/api/special/couponDetailByShareCode',// 分享优惠券模块
  receiveCoupon:Lapi+'/api/user/receiveCoupon',// 通过分享码领取优惠券

  // ===============活动接口===============
  seckillMakeOrder:Lapi+'/api/order/seckillMakeOrder',// 秒杀下单[即将废弃]
  getAgentWeekDays:Lapi+'/api/agent/getWeekDays',// 代理接口模块:获取日期
  getAgentStadiumLis:Lapi+'/api/home/stadiumList',// 代理接口模块:获取酒店列表
  getAgentSeckillOtherStadiums:Lapi+'/api/special/seckillOtherStadiums',// 代理接口模块:代理秒杀酒店列表
  getAgentStadiumDetail:Lapi+'/api/index/stadiumDetail',// 代理接口模块:代理酒店详情
  getAgentSeckillOtherMakeOrder:Lapi+'/api/order/seckillOtherMakeOrder',// 代理接口模块:代理秒杀下单详情[即将废弃]

  // ===============分销接口===============
  fxBuyCdk:Lapi+'/api/agency/buyCdk',// 分销购买激活码
  getCdkOrders:Lapi+'/api/agency/cdkOrders',//分销者获取激活码列表
  getCdkOrderDetail:Lapi+'/api/agency/cdkOrderDetail',//分销激活码订单详情

  // ===============更新或新增的api v2.1.8===============
  getStadiumsVersionTwo:Lapi+'/api/home/stadiumList',// 获取酒店列表 替代getStadiums
  getStadiumDetailVersionTwo:Lapi+'/api/home/stadiumDetail',// 获取单个酒店详情，替代getSingleStadium
  bookFit:Lapi+'/api/order/bookFit',// 沸健身下单[泳健预约下单(有卡 或 无卡)][v2.1.8版本引入]
  bookFitFreePay:Lapi+'/api/order/freePay',//沸健身下单0元[泳健预约下单(有卡 或 无卡)][v2.1.8版本引入]
  bookYoga:Lapi+'/api/order/bookYoga',// 翡瑜伽下单[瑜伽预约下单][v2.1.8版本引入]
  cancelBook:Lapi+'/api/order/cancelBook',// 取消订单[v2.1.8版本引入]
  bookOrderList:Lapi+'/api/order/orderList',// 订单列表[v2.1.8版本引入]
  bookOrderDetail:Lapi+'/api/order/orderDetail',// 订单详情[v2.1.8版本引入]
  bookCancelPay:Lapi+'/api/order/cancelPay',//取消支付。当订单支付失败或取消支付需要执行此步骤用以释放库存[v2.1.8版本引入]
  bookBuyCards:Lapi+'/api/order/buyCards',//购卡[v2.1.8版本引入]
  bookCardsOrderDetail:Lapi+'/api/order/cardsOrderDetail',////购卡成功后查看卡详情[v2.1.8版本引入]
  bookVipCardsUseLogs:Lapi+'/api/user_cards/vipCardsUseLogs',// 查看会员卡权益使用记录

  // ===============活动接口更新或新增的api v2.1.8===============
  bookAgentBookFit:Lapi+'/api/order/agentBookFit',//代理下单[v2.1.8版本引入]
  bookSeckillBookFit:Lapi+'/api/order/seckillBookFit',//秒杀下单[v2.1.8版本引入]

  // ===============活动接口更新或新增的api v2.2.0===============
  flStadiumLists:Lapi+'/api/index/sankestadiums',//根据日期获取健身瑜伽酒店[v2.2.0版本引入]
  wxExport_flStadiumLists:Lapi+'/api/stadium/lists',

  flUserCardsList:Lapi+'/api/user/cardsList',//新用户会员卡列表[v2.2.0版本引入]
  flBuyCardsV2:Lapi+'/api/order/buyCardsV2',//新购卡下单[v2.2.0版本引入]
  flCardsOrderDetailV2:Lapi+'/api/order/cardsOrderDetailV2',//新买卡订单详情[v2.2.0版本引入]
  flUserCardsOrderFee:Lapi+'/api/user/userCardsOrderFee',//下单前获取订单金额及权益消耗信息[v2.2.0版本引入]
  flRecentStadiums:Lapi+'/api/user/recentStadiums',//首页近期去过的酒店[v2.2.0版本引入]
  flCardsDetail:Lapi+'/api/user/cardsDetail',//新用户卡会员卡详情[v2.2.0版本引入]
  flUserInAction:Lapi+'/api/user/userInAction',//领优惠券操作
  flreceiveCouponByTempActivity:Lapi+'/api/user/receiveCouponByTempActivity',


  flGetUserInfoByOpenid:Lapi+'/api/login/getUserInfoByOpenid',//根据openid获取token


  flGetcouponActivityInfo:Lapi+'/api/user/couponActivityInfo',
  flGetreceiveCouponByActivity:Lapi+'/api/user/receiveCouponByActivity',
  flGetcouponsByActivity:Lapi+'/api/user/couponsByActivity',


  Wap:Wapi+'/tool/agencyQrcode',
  toolgetUrlScheme:ampapi+'/tool/getUrlScheme',

  ampapiuserAgreement:ampapi+'/tool/appPrivacyAgreement',
  ampapiprivacyAgreement:ampapi+'/tool/appPrivacyAgreement',

  // 微信分身
  wxseparation_privacyAgreement:Wapi+'/tool/privacyAgreement',//斐燃会员隐私政策
  wxseparation_privacyAgreementnew:Wapi+'/tool/privacyAgreementnew',//斐燃会员隐私政策
  wxseparation_userAgreement:Wapi+'/tool/userAgreement',//斐燃会员用户协议
  wxseparation_userAgreementnew:Wapi+'/tool/userAgreementNew',//斐燃会员用户协议
  wxseparation_beVipAgreement:Wapi+'/tool/beVipAgreement',//斐燃会员开通协议
  wxseparation_beVipAgreementnew:Wapi+'/tool/beVipAgreementnew',//斐燃会员开通协议
  wxseparation_vipUsageAgreement:Wapi+'/tool/vipUsageAgreement',//斐燃会员使用规则
  wxseparation_vipUsageAgreementnew:Wapi+'/tool/vipUsageAgreementnew',//斐燃会员使用规则
}
export default {
	userApi
}



// WEBPACK FOOTER //
// ./src/request/api.js